export default (params) => {
  const { e, ref, show } = params;
  e?.preventDefault();
  const currentElement = ref.current;
  const left = currentElement.offsetLeft + currentElement.clientWidth;
  const top = currentElement.offsetTop;

  return {
    show: !show,
    left,
    top,
  };
};
